import invariant from 'invariant';
import querystring from 'query-string';
import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';

export default function getCategoryBySeoPath(params) {
    let { baseUrl, brandId, country, path, options, uberToken, clientId, clientSecret } = params;

    invariant(baseUrl, 'baseUrl is a required param of getCategoryBySeoPath()');
    invariant(brandId, 'brandId is a required param of getCategoryBySeoPath()');
    invariant(country, 'country is a required param of getCategoryBySeoPath()');
    invariant(path, 'path is a required param of getCategoryBySeoPath()');
    invariant(clientId, 'clientId is a required param of getCategoryBySeoPath()');

    const localisedBrand = `${brandId}_${country.toLowerCase()}`;
    const decodedPath = decode(path);
    const formattedPath = decodedPath[0] === '/' ? decodedPath : '/' + decodedPath;
    const queries = querystring.stringify({
        category: formattedPath.replace(/\/$/, ''),
        ...options,
    });

    const queriesString = queries.length ? `?${queries}` : '';
    const concatUrl = `${baseUrl}search/resources/store/${localisedBrand}/productview/byCategory${queriesString}`;

    return labelRequest(authenticatedRequest(new Request(concatUrl), uberToken, clientId, clientSecret), 'getCategoryBySeoPath');
}

const decode = (path) => {
    let decoded;

    try {
        decoded = decodeURIComponent(path);
    } catch {
        return path;
    }

    return path === decoded ? path : decoded;
};
